import PropTypes from "prop-types";
import { ReactComponent as DownArrow } from "../../../assets/images/negative-variation.svg";
import { ReactComponent as UpArrow } from "../../../assets/images/positive-variation.svg";
import "./Grade.scss";

const Grade = ({ value, variation, simplified, maxGrade, expected_score }) => {
  const getVariationIcon = variation => {
    if (variation < 0) {
      return <DownArrow />;
    } else if (variation > 0) {
      return <UpArrow />;
    } else {
      return <span className="stagnant-symbol" />;
    }
  };


  const formatValue = (val) => {
    if (val === undefined || val === null || val === -1) return "-";
    let normalizedValue;
    if (val > 10) {
      normalizedValue = val / 100;
    } else {
      normalizedValue = val;
    }

    return normalizedValue.toFixed(1);
  };

  return (
    <p
      className={`Grade ${!simplified ? (variation > 0 ? "positive" : "negative") : ""
        }`}
    >
      {formatValue(value)}
      {expected_score !== undefined && expected_score !== null && (
        <> / {formatValue(expected_score)}</>
      )}
      {!simplified && getVariationIcon(variation)}
      {maxGrade && <span className="maxGrade">/{maxGrade}</span>}
    </p>
  );
};

Grade.propTypes = {
  value: PropTypes.string.isRequired
};

export default Grade;
